import React, {lazy} from 'react';
import {createRoot} from 'react-dom/client';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialMeta, getInitialPageState} from "@helpers/HelperInitialPageState";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import {ContextCartProvider} from "@contexts/ContextCartProvider";
import {ContextTLDProvider} from "@contexts/ContextTLDProvider";
import {ContextNotificationProvider} from "@contexts/ContextNotificationProvider";
import styles from './PageShopiko.scss';
import Header from '@components/base/Header/Header';
import Footer from '@components/base/Footer/Footer';
import ShopikoHeaderData from '@components/base/Header/data/ShopikoHeaderData';
import MenuBottom from "@components/base/MenuBottom/MenuBottom";
import language from "@lang/language";

// Load TABS
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////

import Tabs from '@components/base/Tabs/onScroll/Tabs';
import TabAdvantages from './Tabs/TabAdvantages';
import TabPrices from './Tabs/TabPrices';
import TabFAQ from './Tabs/TabFAQ';
// Lazy load other TABS
//const TabPricesLazy = lazy(() => import('./Tabs/TabPrices'));
//const TabFAQLazy = lazy(() => import('./Tabs/TabFAQ'));

const tabsData = [
	{id: 'advantages', label: language.advantages, component: TabAdvantages, default: true},
	{id: 'prices', label: language.plansAndPrices, component: TabPrices},
	{id: 'faq', label: language.faq, component: TabFAQ}
];

//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////

const PageShopiko = (props) => {
	useSHCore({props, name: 'PageShopiko', isPage: true});

	return (
	  <>
		  <ContextCartProvider>
			  <ContextServicePriceProvider>
				  <ContextTLDProvider>
					  <ContextNotificationProvider color={'color-brand-green-400'}>
						  <Header data={ShopikoHeaderData}/>

						  <main>
							  <Tabs
								tabs={tabsData}
								color={'color-brand-green-400'}
							  />

							  <MenuBottom serviceType={'PlanShop'} color={'color-brand-green-400'}/>
						  </main>

						  <Footer color={'color-brand-green-400'}/>
					  </ContextNotificationProvider>
				  </ContextTLDProvider>
			  </ContextServicePriceProvider>
		  </ContextCartProvider>
	  </>
	)
};

const container = document.getElementById(getInitialMeta('pageAppId'));
const root = createRoot(container);
root.render(<PageShopiko data={getInitialPageState()}/>);
